import type { HostPublicProfile } from '@/mocks/hostProfile';

interface Props {
  profile: HostPublicProfile;
}

export default function HostBadgesSection({ profile }: Props) {
  const earned = profile.badges.filter((b) => b.earned);
  const locked = profile.badges.filter((b) => !b.earned);

  return (
    <section id="insignias" className="scroll-mt-24">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-foreground-950 flex items-center gap-2">
          <i className="ri-medal-line text-accent-500"></i>
          Insignias
        </h2>
        <span className="text-xs text-foreground-500 bg-background-100 px-2 py-1 rounded-full">
          {earned.length}/{profile.badges.length} obtenidas
        </span>
      </div>

      {/* Earned */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 mb-4">
        {earned.map((badge) => (
          <div key={badge.id} className="group bg-white rounded-xl border border-accent-200 p-4 text-center cursor-default hover:shadow-sm transition-all">
            <div className="w-10 h-10 mx-auto rounded-full bg-accent-100 flex items-center justify-center mb-2">
              <i className={`${badge.icon} text-accent-600 text-lg`}></i>
            </div>
            <h3 className="text-xs font-semibold text-foreground-950 leading-snug">{badge.name}</h3>
            <p className="text-[10px] text-foreground-500 mt-1 leading-snug">{badge.description}</p>
            <span className="inline-block mt-2 text-[10px] bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full font-medium">
              Obtenida
            </span>
          </div>
        ))}

        {/* Locked */}
        {locked.map((badge) => (
          <div key={badge.id} className="group bg-background-50 rounded-xl border border-dashed border-foreground-200 p-4 text-center cursor-default opacity-70 hover:opacity-100 transition-all">
            <div className="w-10 h-10 mx-auto rounded-full bg-foreground-100 flex items-center justify-center mb-2">
              <i className={`${badge.icon} text-foreground-400 text-lg`}></i>
            </div>
            <h3 className="text-xs font-semibold text-foreground-500 leading-snug">{badge.name}</h3>
            <p className="text-[10px] text-foreground-400 mt-1 leading-snug">{badge.description}</p>
            <span className="inline-block mt-2 text-[10px] bg-foreground-100 text-foreground-500 px-2 py-0.5 rounded-full font-medium">
              Bloqueada
            </span>
          </div>
        ))}
      </div>

      {/* Progress bar */}
      <div className="bg-white rounded-xl border border-foreground-100 p-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-xs text-foreground-600">Progreso total de insignias</span>
          <span className="text-xs font-bold text-foreground-950">{earned.length}/{profile.badges.length}</span>
        </div>
        <div className="w-full h-2 bg-background-100 rounded-full overflow-hidden">
          <div
            className="h-full bg-accent-500 rounded-full transition-all"
            style={{ width: `${(earned.length / profile.badges.length) * 100}%` }}
          ></div>
        </div>
      </div>
    </section>
  );
}